import React from 'react';
import './About.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const teamMembers = [
  {
    name: 'Tithi Gautam Tewari',
    position: 'Founder and MD',
    image: '/team/Tithii.webp',
  },
  {
    name: 'Gautam Tewari',
    position: 'Co-Founder & CPO',
    image: '/team/gautam.webp',
  },
 
   {
    name: 'Shamima Nadia',
    position: 'Chief of Staff',
    image: '/team/nadiaa.png',
  },
  {
    name: 'Vikas Sharma',
    position: 'Head - Finance and Taxation',
    image: '/team/vikasji.webp',
  },
  {
    name: 'Mukesh Jain',
    position: 'Head - Projects',
    image: '/team/mk.png',
  },
  

   {
    name: 'Disha Singh',
    position: 'Head - Design and Business Growth',
    image: '/team/disha.png',
  },
   {
    name: 'Deepak Mani Tiwari',
    position: 'Head - Procurement and Costing',
    image: '/team/deepaktiwari.png',
  },
    {
    name: 'Naveen Vashisht',
    position: 'Project Manager',
    image: '/team/nav.png',
  },
    {
    name: 'Rafique Alam',
    position: 'Principal - Cost Consulting',
    image: '/team/RafiqueAlam.jpg',
  },
    {
    name: 'Sejal Agarwal',
    position: 'Associate Interior Designer',
    image: '/team/sejal.png',
  }, {
    name: 'Sarita Yadav',
    position: 'Architect',
    image: '/team/sarita.jpg',
  },
     {
    name: 'Arpan Panikulam',
    position: 'Interior Designer',
    image: '/team/ar.jpeg',
  },
  {
    name: 'Devesh Kumar',
    position: 'Project Manager',
    image: '/dev.png',
  },

  
];
const About = () => {
  return (
  <>
      <Navbar /> {/* ✅ Navbar at the top */}

    <div className='about-page'>


    
      {/* Our Team Section — ADDED BELOW YOUR SLIDER */}
<section className="team-section">
  {/* Video as background */}
  <video className="bg-video" autoPlay loop muted playsInline>
    <source src="/backvid.mp4" type="video/mp4" />
  </video>

  <div className="team-content"> {/* Content goes above the video */}
    <h2 className="team-heading">Our Team</h2>
    
    <div className="team-card-container">
      {teamMembers.map((member, index) => (
        <div className="team-card" key={index}>
          <div
            className="team-image"
            style={{ backgroundImage: `url(${member.image})` }}
          />
          <div className="team-info">
            <h4>{member.name}</h4>
            <p>{member.position}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


    </div>
    <Footer /> {/* ✅ Footer at the bottom */}
    </>
  );
};

export default About;